/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_History_DiscardedInputs */

const en_us2_plan_history_discarded = /** @type {(inputs: Plan_History_DiscardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discarded`)
};

const pt_br2_plan_history_discarded = /** @type {(inputs: Plan_History_DiscardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartado`)
};

const es_419_plan_history_discarded = /** @type {(inputs: Plan_History_DiscardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartado`)
};

const pt_pt2_plan_history_discarded = /** @type {(inputs: Plan_History_DiscardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartado`)
};

const fr_fr2_plan_history_discarded = /** @type {(inputs: Plan_History_DiscardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abandonné`)
};

const de_de2_plan_history_discarded = /** @type {(inputs: Plan_History_DiscardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verworfen`)
};

const it_it2_plan_history_discarded = /** @type {(inputs: Plan_History_DiscardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scartata`)
};

/**
* | output |
* | --- |
* | "Discarded" |
*
* @param {Plan_History_DiscardedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_history_discarded = /** @type {((inputs?: Plan_History_DiscardedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_History_DiscardedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_history_discarded(inputs)
	if (locale === "es-419") return es_419_plan_history_discarded(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_history_discarded(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_history_discarded(inputs)
	if (locale === "de-DE") return de_de2_plan_history_discarded(inputs)
	if (locale === "it-IT") return it_it2_plan_history_discarded(inputs)
	return en_us2_plan_history_discarded(inputs)
});
export { plan_history_discarded as "plan.history_discarded" }